import validationPatterns from "../utils/validationPatterns";
const alphanumericRegex = new RegExp(validationPatterns.ALPHANUMERIC);
export const restrictToAlphaNumericKey = (e) => {
    const isAlphanumeric = alphanumericRegex.test(e.key);
    if (!isAlphanumeric)
        e.preventDefault();
    return isAlphanumeric;
};
//# sourceMappingURL=restrictToAlphaNumericKey.js.map